<template>
  <dialog-base
    v-bind:shows="shows"
    v-bind:initialize-callback="$_onInitialize"
    v-bind:ok-callback="$_onOkClicked"
    v-bind:finalize-callback="finalizeCallback"
    v-bind:ok-disabled="$_isNoTimelineDataSelected"
  >
    <template v-slot:body>
      <v-card-title>Select Timeline Data</v-card-title>
      <v-card-text>
        <v-checkbox
          dense
          v-for="(timelineDataSelectionWithInfo, timelineDataId) in $_timelineDataSelectionWithInfoSet"
          v-bind:input-value="$_isSelected(timelineDataId)"
          v-bind:disabled="$_isCheckBoxDisabled[timelineDataId]"
          v-bind:label="timelineDataSelectionWithInfo.selectionItemLabel"
          v-bind:key="timelineDataId"
          v-on:change="$_selectTimelineData(timelineDataId, $event)"
        >
        </v-checkbox>
      </v-card-text>
    </template>
  </dialog-base>
</template>

<script>
import { TimelineDataSet, TimelineSegmentDataBase } from '../../modules/ScattData.js';
import DialogBase from './DialogBase.vue';

class TimelineDataSelectionWithInfo {
  static name = 'TimelineDataSelectionWithInfo';

  constructor(timelineDataId, segmentDataType, timelineDataName) {
    this.segmentDataType = segmentDataType;
    this.selectionItemLabel = `[${timelineDataId}] ${timelineDataName} (${segmentDataType})`;
  }
}

export default {
  components: {
    DialogBase,
  },

  props: {
    shows:                   { type: Boolean },
    okCallback:              { type: Function },
    finalizeCallback:        { type: Function },
    timelineDataSet:         { type: TimelineDataSet },
    disabledTimelineDataIds: { type: Array, default: () => [] },
    segmentDataType:         { type: TimelineSegmentDataBase },
    multiple:                { type: Boolean, default: true },
  },

  data() {
    return {
      $_selectedTimelineDataIds: [],
    };
  },

  computed: {
    $_timelineDataSelectionWithInfoSet() {
      let timelineDataSelectionWithInfoSet = {};
      if (this.timelineDataSet !== undefined) {
        for (let [ timelineDataId, timelineData ] of Object.entries(this.timelineDataSet)) {
          timelineDataSelectionWithInfoSet[timelineDataId] = new TimelineDataSelectionWithInfo(timelineDataId, timelineData.segmentDataType, timelineData.name);
        }
      }
      return timelineDataSelectionWithInfoSet;
    },

    $_isNoTimelineDataSelected() {
      return (this.$_currentSegmentDataType === undefined);
    },

    $_onlyOneSelectedTimelineDataId() {
      if (this.$data.$_selectedTimelineDataIds.length !== 1) return undefined;
      return this.$data.$_selectedTimelineDataIds[0];
    },

    $_isCheckBoxDisabled() {
      let isCheckBoxDisabled = {};
      if (!this.multiple && (this.$_onlyOneSelectedTimelineDataId !== undefined)) {
        for (let timelineDataId of Object.keys(this.timelineDataSet)) {
          isCheckBoxDisabled[timelineDataId] = (this.$_onlyOneSelectedTimelineDataId !== timelineDataId);
        }
      } else {
        for (let [ timelineDataId, timelineDataSelectionWithInfo ] of Object.entries(this.$_timelineDataSelectionWithInfoSet)) {
          if (this.disabledTimelineDataIds.includes(timelineDataId)) {
            isCheckBoxDisabled[timelineDataId] = true;
          } else if (this.$_isNoTimelineDataSelected) {
            isCheckBoxDisabled[timelineDataId] = false;
          } else {
            isCheckBoxDisabled[timelineDataId] = (timelineDataSelectionWithInfo.segmentDataType !== this.$_currentSegmentDataType);
          }
        }
      }
      return isCheckBoxDisabled;
    },

    $_currentSegmentDataType() {
      if (this.segmentDataType !== undefined) return this.segmentDataType;
      for (let timelineDataId of this.$data.$_selectedTimelineDataIds) {
        return this.$_timelineDataSelectionWithInfoSet[timelineDataId].segmentDataType;
      }
      return undefined;
    },
  },

  methods: {
    $_onInitialize() {
      this.$data.$_selectedTimelineDataIds.splice(0);
    },

    $_onOkClicked() {
      this.okCallback(
        this.$_currentSegmentDataType,
        (this.multiple)? this.$data.$_selectedTimelineDataIds : this.$data.$_selectedTimelineDataIds[0],
      );
    },

    $_isSelected(timelineDataId) {
      return this.$data.$_selectedTimelineDataIds.includes(timelineDataId);
    },

    $_selectTimelineData(timelineDataId, isSelected) {
      let foundExistingTimelineDataIdx = this.$data.$_selectedTimelineDataIds.indexOf(timelineDataId);
      if (isSelected) {
        if (foundExistingTimelineDataIdx === -1) {
          this.$data.$_selectedTimelineDataIds.push(timelineDataId);
        }
      } else {
        if (foundExistingTimelineDataIdx !== -1) {
          this.$data.$_selectedTimelineDataIds.splice(foundExistingTimelineDataIdx, 1);
        }
      }
    },
  },
}
</script>
